const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__content">
        <div className="footer__info">
          <h3>RAYS</h3>
          <p>Rajagiri Association of Yesteryear Students</p>
        </div>
        <div className="footer__links">
          <div className="footer__section">
            <h4>Quick Links</h4>
            <a href="/about">About</a>
            <a href="/events">Events</a>
            <a href="/resources">Resources</a>
            <a href="/contact">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 